import { Skeleton } from '@/global/components/Skeleton'

const OneColumnListItemSkeleton = () => {
  return (
    <div data-testid='one-column-list-item-skeleton'>
      {Array.from({ length: 4 }, (_, k) => k).map(index => (
        <div
          className='py-gl-spacing-08 px-gl-spacing-06 flex gap-gl-spacing-06 items-center'
          key={index}
        >
          <Skeleton
            variant='rectangular'
            height='h-[74px]'
            width='w-[74px]'
          />
          <div className='flex flex-col gap-gl-spacing-03'>
            <Skeleton
              variant='rounded'
              height='h-[13px]'
              width='w-[284px]'
            />
            <Skeleton
              variant='rounded'
              height='h-[13px]'
              width='w-[284px]'
            />
            <Skeleton
              variant='rounded'
              height='h-[13px]'
              width='w-[189px]'
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export { OneColumnListItemSkeleton }
